import axios from 'axios';
import { createHeaders } from './headerUtils';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const intercomService = {
	searchConversations: async ({
		page = 1,
		perPage = 10,
		email = '',
		status = '',
		conversationId = '',
		startingAfter = '',
	} = {}) => {
		try {
			const payload = {
				page,
				per_page: perPage,
			};

			if (email) {
				payload.email = email;
			}
			if (status) {
				payload.status = status;
			}
			if (conversationId) {
				payload.conversation_id = conversationId;
			}
			if (startingAfter) {
				payload.starting_after = startingAfter;
			}

			const apiUrl = `${BASE_URL}/intercom/conversations/search`;
			const headers = createHeaders();
			const response = await axios.post(apiUrl, payload, { headers });
			return response.data;
		} catch (error) {
			console.log('intercomService (ERROR): searchConversations', error.message);
			throw error;
		}
	},
	searchTickets: async ({
		page = 1,
		perPage = 10,
		open = '',
		state = '',
		accountId = '',
		conversationId = '',
		ticketId = '',
		startingAfter = '',
	} = {}) => {
		try {
			const payload = {
				page,
				per_page: perPage,
			};

			if (open !== '') {
				payload.open = open;
			}
			if (state) {
				payload.state = state;
			}
			if (accountId) {
				payload.account_id = accountId;
			}
			if (conversationId) {
				payload.conversation_id = conversationId;
			}
			if (ticketId) {
				payload.ticket_id = ticketId;
			}
			if (startingAfter) {
				payload.starting_after = startingAfter;
			}

			const apiUrl = `${BASE_URL}/intercom/tickets/search`;
			const headers = createHeaders();
			const response = await axios.post(apiUrl, payload, { headers });
			return response.data;
		} catch (error) {
			console.log('intercomService (ERROR): searchTickets', error.message);
			throw error;
		}
	},
	getConversationById: async (conversationId) => {
		try {
			const apiUrl = `${BASE_URL}/intercom/conversation/${conversationId}`;
			const headers = createHeaders();
			const response = await axios.get(apiUrl, { headers });
			return response.data;
		} catch (error) {
			console.log('intercomService (ERROR): getConversationById', error.message);
			throw error;
		}
	},
	getTicketById: async (ticketId) => {
		try {
			const apiUrl = `${BASE_URL}/intercom/tickets/${ticketId}`;
			const headers = createHeaders();
			const response = await axios.get(apiUrl, { headers });
			return response.data;
		} catch (error) {
			console.log('intercomService (ERROR): getTicketById', error.message);
			throw error;
		}
	},
	escalateTicket: async (conversationId, reason) => {
		try {
			const apiUrl = `${BASE_URL}/intercom/tickets/escalate/${conversationId}`;
			const headers = createHeaders();
			const response = await axios.post(apiUrl, { note: reason }, { headers });
			return response.data;
		} catch (error) {
			console.log('intercomService (ERROR): escalateTicket', error.message);
			throw error;
		}
	},
	// NOTE: endpoint path/payload below are placeholders — align with the real backend route.
	updateTicketAttributes: async (ticketId, attributes) => {
		try {
			const apiUrl = `${BASE_URL}/intercom/tickets/${ticketId}/attributes`;
			const headers = createHeaders();
			const response = await axios.put(apiUrl, { attributes }, { headers });
			return response.data;
		} catch (error) {
			console.log('intercomService (ERROR): updateTicketAttributes', error.message);
			throw error;
		}
	},
	// NOTE: endpoint path/payload below are placeholders — align with the real backend route.
	summarizeBotFields: async (ticketId) => {
		try {
			const apiUrl = `${BASE_URL}/intercom/tickets/${ticketId}/bot-fields/summarize`;
			const headers = createHeaders();
			const response = await axios.post(apiUrl, {}, { headers });
			return response.data;
		} catch (error) {
			console.log('intercomService (ERROR): summarizeBotFields', error.message);
			throw error;
		}
	},
};

export default intercomService;
